module.exports = __webpack_public_path__ + "static/media/background1.7aebc184.jpg";